import {
    VIRTUAL_STATION_SCAN_ERROR,
    VIRTUAL_STATION_SCAN_SUCCESS,
    VIRTUAL_STATION_SET_LOADING,
    VIRTUAL_STATION_START_COUNTDOWN,
    VIRTUAL_STATION_START_POLLING,
    VIRTUAL_STATION_STOP_COUNTDOWN,
    VIRTUAL_STATION_STOP_POLLING,
    VIRTUAL_STATION_UPDATE_POLLING_STATUS,
    VIRTUAL_STATION_SET_OPEN_QR_SCANNER,
} from './virtualStationActions';

const INIT_STATE = {
  isPolling: false,
  countdown: 30, // 30 seconds initial countdown
  isLoading: false,
 scanResult: null,
  scanError: null,
  openQrScanner: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case VIRTUAL_STATION_START_POLLING:
      return {
        ...state,
        isPolling: true,
      };
    case VIRTUAL_STATION_STOP_POLLING:
      return {
        ...state,
        isPolling: false,
      };
    case VIRTUAL_STATION_UPDATE_POLLING_STATUS:
      return {
        ...state,
        pollingStatus: action.payload,
      };
    case VIRTUAL_STATION_START_COUNTDOWN:
      return {
        ...state,
        countdown: action.payload,
      };
    case VIRTUAL_STATION_STOP_COUNTDOWN:
      return {
        ...state,
        countdown: 30, // Reset to initial value
      };
    case VIRTUAL_STATION_SET_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case VIRTUAL_STATION_SCAN_SUCCESS:
      return {
        ...state,
        scanResult: action.payload,
        scanError: null,
      };
    case VIRTUAL_STATION_SCAN_ERROR:
      return {
        ...state,
        scanResult: null,
        scanError: action.payload,
      };
    case VIRTUAL_STATION_SET_OPEN_QR_SCANNER:
      return {
        ...state,
        openQrScanner: action.payload,
      };
    default:
      return state;
  }
};
